import { BookOpenTextIcon, BotIcon, CalendarCheckIcon, CalendarXIcon, ClipboardCheckIcon, CogIcon, FolderSearchIcon, LayoutGridIcon, LightbulbIcon, PencilRulerIcon, ShieldCheckIcon, ShuffleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// =====================================================================
// ВЕРОНАУКА СПРЕМНА™ – all landing content. GENERADO por fabrica/gen_landing.py desde la ficha (veronauka-spremna). No editar a mano: editar la ficha.
// =====================================================================

import { MOCKUP_URL, PAGE_URLS, pageTexts } from './teknikMedia';
export { MOCKUP_URL, PAGE_URLS };

export const PRODUCT_IMAGE = MOCKUP_URL;
export const PRODUCT_IMAGE_ALT = 'Пакет ВЕРОНАУКА СПРЕМНА: шест томова веронауке за 1–8. разред са годишњим планом, часовима, листићима, тестовима и оцењивањем';

export const PRICE = '2490 дин.';
export const ORIGINAL_PRICE = '5990 дин.';

export const META = {
  title: 'ВЕРОНАУКА СПРЕМНА™ – Готови часови веронауке за 1–8. разред',
  description: 'Готов 6-у-1 систем за веронауку 1–8. разред: годишњи план, часови минут по минут, Свето писмо, празници, светитељи и храм, вредности, тестови и оцењивање, плус 5 бонуса.',
  ogTitle: 'ВЕРОНАУКА СПРЕМНА™ – Твоја година веронауке – 100% спремна',
  ogDescription: 'Цела школска година веронауке – спремна. Часови, листићи у три нивоа, тестови и решења за 1–8. разред. Тренутно преузимање.'
};

export const topBar = {
  long: 'Цела школска година веронауке – спремна · Тренутно преузимање · 7 дана гаранције задовољства',
  short: 'Цела година веронауке · 7 дана гаранције'
};

export const copy = {
  ctaDefault: 'Набавите ВЕРОНАУКУ СПРЕМНУ™ одмах',
  hero: {
    before: 'Добијте',
    highlight: 'целу школску годину',
    middle: 'веронауке спремну – почните за',
    accent: '5 минута',
    sub: 'Твоја година веронауке – 100% спремна. Шест дигиталних томова за 1–8. разред: годишњи план, часови минут по минут, листићи у три нивоа, тестови и оцењивање.',
    badgeLine1: '6 томова',
    badgeLine2: '+ 5 бонуса'
  },
  stats: {
    title: 'Цео пакет у бројевима'
  },
  difference: {
    kicker: 'Разлика са ВЕРОНАУКОМ СПРЕМНОМ™',
    titleStart: 'Од импровизације на веронауци до',
    titleAccent: 'мира и структуре.',
    intro: 'Замислите да недељу почињете са часовима веронауке који су већ планирани. Знате шта ћете рећи, која питања можете да поставите и које листиће ће ученици добити.',
    beforeLabel: 'Пре ВЕРОНАУКЕ СПРЕМНЕ™',
    beforeTitle: 'Препознајете ли се?',
    afterLabel: 'Са ВЕРОНАУКОМ СПРЕМНОМ™',
    afterTitle: 'Мање припремања. Више часа.',
    closing: 'Искористите време за ученике који слушају, питају и размишљају – а не за тражење материјала.'
  },
  recognize: {
    title: 'Да ли Вам је ово познато?',
    text: 'Ако на бар једно питање одговорите потврдно, ВЕРОНАУКА СПРЕМНА™ је за Вас.',
    link: 'Заслужујете лакши пут'
  },
  inside: {
    title: 'Шта садржи',
    brand: 'ВЕРОНАУКА СПРЕМНА™',
    packTitle: 'Чиме се ВЕРОНАУКА СПРЕМНА™ разликује?',
    packText: 'Материјал за целу школску годину веронауке – Свето писмо, црквена година и празници, светитељи, иконе и храм, вредности и молитва, оцењивање – у једном систему.'
  },
  pages: {
    kicker: 'Завирите у ВЕРОНАУКУ СПРЕМНУ™',
    titleStart: 'Погледајте како материјал изгледа',
    titleAccent: 'изнутра.',
    text: 'Праве странице из Тома 1: годишњи план, наставничке стране минут по минут са циљем и безбедним оквиром, листићи у три нивоа и критеријуми оцењивања.'
  },
  bonuses: {
    kicker: 'Али то није све!',
    titleStart: '5 бонуса',
    titleAccent: 'без додатног трошка',
    text: 'Пет додатних ресурса долази уз шест томова – да будете спремни за све што се дешава у учионици.'
  },
  how: {
    titleStart: 'Како функционише',
    brand: 'ВЕРОНАУКА СПРЕМНА™',
    text: 'Од преузимања до учионице: припремите следећи час веронауке за свега неколико минута.',
    closing: 'Отворите → изаберите → припремите → предајте. Једноставно и прегледно.'
  },
  audience: {
    titleStart: 'За кога је',
    brand: 'ВЕРОНАУКА СПРЕМНА™',
    lead: 'Пакет је за Вас који:',
    closing: 'Направљено за вероучитеље који желе да мање времена троше на тражење, а више на ученике.',
    asideTitle: 'Колико вреди Ваше време?',
    asideLead: 'Размислите колико сати недељно трошите на припрему веронауке:',
    asideText: 'Замислите готов пакет који Вам помаже у свему овоме – и враћа Вам вече.',
    asideClosing: 'Не морате да почињете од нуле.'
  },
  offer: {
    titleStart: 'Откријте свој комплетан',
    brand: 'ВЕРОНАУКА СПРЕМНА™',
    titleEnd: ' пакет',
    text: 'Цела школска година веронауке – спремна. Почните за 5 минута.',
    includesLabel: 'Комплетан пакет садржи',
    priceLabel: 'Уводна цена',
    originalLabel: 'Редовна цена',
    oneTime: 'Једнократно плаћање. Без претплате.',
    cta: 'Набавите цео пакет одмах'
  },
  guarantee: {
    title: '7 дана гаранције задовољства',
    text: 'Преузмите материјал и погледајте како функционише на Вашој веронауци.',
    legal: 'Гаранција не утиче на Ваша права према важећем закону о заштити потрошача.'
  },
  finalCta: {
    titleStart: 'Ваша веронаука може бити',
    titleAccent: 'спремна већ данас.',
    text: 'Уместо да тражите приче, датуме и листиће, можете да отворите час, одштампате листић и уђете у учионицу са јасним планом.',
    closing: 'Ваши ученици. Ваша настава. Ваше слободно време.',
    recap: ['6 томова', '240 страна', '12 часова у Тому 1', 'Листићи у 3 нивоа', 'Тестови + решења', '5 бонуса'],
    oneTime: 'Једнократно плаћање – без претплате.',
    reassurances: ['Тренутно дигитално преузимање', 'ПДФ датотеке за чување', '7 дана гаранције задовољства']
  },
  footer: {
    brand: 'ВЕРОНАУКА СПРЕМНА',
    disclaimer: 'ВЕРОНАУКА СПРЕМНА™ је самосталан наставни материјал за веронауку у 1–8. разреду. Није издање нити одобрење Српске православне цркве, Министарства просвете или било које школе.',
    copyright: '© 2026 ВЕРОНАУКА СПРЕМНА™ · edulabs. Сва права задржана.'
  }
};

export const heroGuarantees = ['Тренутно дигитално преузимање', 'Једнократно плаћање', 'Без претплате', '7 дана гаранције задовољства'];

export const stats = [{
  value: '240',
  label: 'Страна у шест томова'
}, {
  value: '12',
  label: 'Часова минут по минут у Тому 1'
}, {
  value: '3',
  label: 'Нивоа у сваком листићу'
}, {
  value: '100',
  label: 'Готових коментара'
}, {
  value: '5',
  label: 'Бонуса је укључено'
}];

export const differenceStats = [{
  value: '1–8. разред',
  label: 'Годишњи план за 1–4, 5–6. и 7–8. разред'
}, {
  value: '6 дигиталних томова',
  label: 'Часови, Свето писмо, празници, светитељи, вредности и оцењивање'
}, {
  value: 'ПДФ за штампу',
  label: 'За штампање за учионицу или приказ на екрану'
}];

export const beforeItems: Array<{
  title: string;
  text: string;
}> = [{
  title: 'Недеља увече иде на припрему',
  text: 'Тражите приче, датуме и листиће – а недеља још није ни почела.'
}, {
  title: 'Прави датуми празника',
  text: 'Желите да сваки празник буде тачан по јулијанском календару, без претраживања.'
}, {
  title: 'Безбедан оквир за сваку породицу',
  text: 'Желите да час буде поштован за све ученике, без притиска да верују или да се моле.'
}, {
  title: 'Питања која долазе без најаве',
  text: 'Ученици питају о смрти, Богу и молитви – а Ви желите да одговорите мирно и тачно.'
}, {
  title: 'Родитељи и колеге питају',
  text: 'Треба Вам јасно писмо, план за замену и водич за посету храму.'
}, {
  title: 'Описно оцењивање одузима вечери',
  text: 'Критеријуми, тестови и коментари постају додатни посао после наставе.'
}];

export const afterItems = ['Организован пакет за веронауку за целу основну школу', 'Годишњи план за 1–4, 5–6. и 7–8. разред', '12 готових часова са наставничком страном и листићима у три нивоа', 'Свето писмо, празници по јулијанском календару и црквена година', 'Светитељи, иконе и храм', 'Хришћанске вредности и молитва у свакодневици', 'Тестови А/Б са решењима и описно оцењивање', '100 готових коментара'];

export const recognizeItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: CalendarXIcon,
  title: 'Вечери иду на припрему',
  text: 'Да ли недељом увече припремате часове веронауке за наредну недељу?'
}, {
  icon: FolderSearchIcon,
  title: 'Тражите прецизне датуме',
  text: 'Да ли проверавате датуме празника по јулијанском календару?'
}, {
  icon: ShieldCheckIcon,
  title: 'Безбедан разговор мора да успе',
  text: 'Желите ли јасна правила и безбедан оквир које ученици заиста поштују?'
}, {
  icon: PencilRulerIcon,
  title: 'Не желите све од нуле',
  text: 'Желите ли да часови, листићи и тестови већ буду спремни?'
}, {
  icon: ShuffleIcon,
  title: 'Ученици имају различите потребе',
  text: 'Треба ли Вам задатак у три нивоа – за ученике којима треба подршка и оне који желе изазов?'
}, {
  icon: LayoutGridIcon,
  title: 'Цела веронаука у једном систему',
  text: 'Желите ли Свето писмо, празнике, светитеље, вредности и оцењивање на једном месту?'
}];

export const volumes: Array<{
  number: string;
  level: string;
  title: string;
  tagline: string;
  intro: string;
  items: string[];
  outro: string;
  note?: string;
  spine: string;
  rule: string;
}> = [{
  number: 'Том 01',
  level: 'Годишњи план',
  title: 'Годишњи план + 12 часова минут по минут',
  tagline: 'Твоја година веронауке – 100% спремна.',
  intro: 'Први том даје Вам структуру за целу школску годину и дванаест готових часова од 45 минута – са наставничком страном и листићима у три нивоа.',
  items: ['Годишњи план за 1–4, 5–6. и 7–8. разред', 'Школска година недељу по недељу', 'Табела прогресије', 'Исходи по разреду', 'Безбедан разговор на веронауци', '12 часова минут по минут (45 мин)', 'Листићи у 3 нивоа', 'Тестови са решењима и критеријуми'],
  outro: 'Од „Бог је створио свет” у 1. разреду до „Љубав, опроштај и одговорност” у 8. разреду.',
  spine: 'bg-[#2B1F3D] text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 02',
  level: 'Свето писмо',
  title: 'Свето писмо – приче за децу по узрасту',
  tagline: 'Причајте са поштовањем.',
  intro: 'Други том даје Вам 16 готових часова о причама Старог и Новог завета, прилагођених узрасту.',
  items: ['Адам и Ева, Ноје, Аврам, Јосиф', 'Мојсије, Давид, Данило, Јона', 'Благовести и Крштење Господње', 'Кана Галилејска, Сејач, Закхеј', 'Тајна вечера', 'Распеће и Васкрсење', 'Педесетница', 'Тест и речник појмова'],
  outro: 'Сви часови користе „православни хришћани верују” – нико није обавезан да верује.',
  spine: 'bg-[#8E2A3C] text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 03',
  level: 'Црквена година',
  title: 'Црквена година и празници',
  tagline: 'Прави датуми, прави обичаји.',
  intro: 'Трећи том даје Вам 16 часова о празницима од Црквене нове године до Видовдана.',
  items: ['Крстовдан, Покров, Митровдан', 'Арханђеловдан и Никољдан', 'Бадњи дан и Богојављење', 'Јовањдан и Сретење', 'Благовести и Цвети', 'Васкршњи обичаји', 'Ђурђевдан, Спасовдан и Духови', 'Видовдан'],
  outro: 'Датуми по јулијанском календару, уз грегоријанске датуме у загради.',
  spine: 'bg-[#C9962B] text-slate-900',
  rule: 'border-slate-900/20'
}, {
  number: 'Том 04',
  level: 'Светитељи и храм',
  title: 'Светитељи, иконе и храм',
  tagline: 'Читајте слику, чујте тишину.',
  intro: 'Четврти том даје Вам 16 часова о светитељима, иконама, иконостасу, манастирима и понашању у храму.',
  items: ['Свети Симеон Мироточиви', 'Манастири Србије', 'Свети кнез Лазар', 'Свети Георгије и Света Петка', 'Иконе и иконостас', 'Свећа и кандило', 'Свештенство, појање и звона', 'Мој светац – пројекат'],
  outro: 'Мирно, поштовано и прилагођено узрасту.',
  spine: 'bg-[#2F7D5B] text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 05',
  level: 'Вредности',
  title: 'Хришћанске вредности и молитва у свакодневици',
  tagline: 'Вредности у делу.',
  intro: 'Пети том даје Вам 16 часова о љубави, захвалности, опроштају, миру и молитви.',
  items: ['Заповест љубави', 'Захвалност', 'Опроштај и мир', 'Блаженства', 'Дељење и милосрђе', 'Истина и пријатељство', 'Врсте молитве', 'Пост, брига о природи и добротворност'],
  outro: 'Молитву нико не мора да изговара наглас.',
  spine: 'bg-[#2A6FA8] text-white',
  rule: 'border-white/30'
}, {
  number: 'Том 06',
  level: 'Оцењивање',
  title: 'Оцењивање и праћење',
  tagline: 'Оцените шта ученик зна и ради – а не шта верује.',
  intro: 'Шести том даје Вам критеријуме, тестове А/Б са решењима и 100 готових коментара за описно оцењивање.',
  items: ['Принципи описног оцењивања', 'Критеријуми 1–2, 3–4, 5–6. и 7–8. разред', 'Евиденција, самопроцена и портфолио', 'Тестови А/Б са решењима', '100 готових коментара', 'Родитељски састанак', 'Документација за педагога', 'Календар оцењивања'],
  outro: 'Оцењивање је описно и не мери лично уверење ученика.',
  spine: 'bg-[#B5532A] text-white',
  rule: 'border-white/30'
}];

export const volumesIntro = {
  title: '6 дигиталних томова за 1–8. разред',
  text: 'Комплетан пакет за веронауку који Вам помаже да планирате и водите наставу целе школске године. Сваки том садржи 40 страна са часовима, листићима и решењима.'
};

export const packItems: Array<{
  icon: LucideIcon;
  title: string;
  text: string;
}> = [{
  icon: BookOpenTextIcon,
  title: 'Часови минут по минут',
  text: 'Не почињите са празним документом. 12 часова од 45 минута са циљем, материјалом, безбедним оквиром и листићима у три нивоа.'
}, {
  icon: CogIcon,
  title: 'Свето писмо',
  text: 'Приче за децу по узрасту: од стварања света до Педесетнице.'
}, {
  icon: LightbulbIcon,
  title: 'Црквена година и празници',
  text: 'Божић, Крсна слава, Савиндан, Васкрс и други празници – са датумима по јулијанском календару.'
}, {
  icon: BotIcon,
  title: 'Светитељи, иконе и храм',
  text: 'Светитељи, иконе, иконостас, манастири и мирно понашање у храму.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Оцењивање',
  text: 'Критеријуми описног оцењивања, тестови А/Б са решењима и 100 готових коментара.'
}, {
  icon: CalendarCheckIcon,
  title: 'Годишњи план',
  text: 'Годишњи план за 1–4, 5–6. и 7–8. разред, школска година недељу по недељу и табела прогресије.'
}];

export const pageTypes = ['Часови минут по минут', 'Листићи у 3 нивоа', 'Безбедан оквир у сваком часу', 'Критеријуми оцењивања'];

export const bonuses: Array<{ title: string; text: string; items: string[]; benefit: string }> = [{
  title: 'Веронаука за 5 минута',
  text: '40 кратких почетака који одмах покрећу час – са одговорима.',
  items: ['10 „Шта је ово?”', '10 „Тачно или нетачно?”', '10 „Празници и датуми”', '10 „Шта би ти урадио/ла?”'],
  benefit: 'Започните сваки час фокусирано – без додатне припреме.'
}, {
  title: 'Мапа замене за веронауку',
  text: '10 часова које заменик може да одржи без припреме.',
  items: ['Моје омиљено место', 'Ноје и барка', 'Ланац захвалности', 'Милосрдни Самарјанин', 'Упутство и решења'],
  benefit: 'Мир и ред и када не можете да будете ту.'
}, {
  title: 'Комуникација са родитељима',
  text: 'Осам готових писама и образаца за контакт са породицама.',
  items: ['Почетак године', 'Пре великог празника', 'Позив на посету храму', 'Разговор о избору предмета', 'Недељни извештај'],
  benefit: 'Јасна комуникација за пар минута.'
}, {
  title: 'Водич за посету храму и манастиру',
  text: 'Шест готових посета са припремом, правилима и питањима.',
  items: ['Пре посете', 'Током посете', 'Добра питања', 'Размишљање после'],
  benefit: 'Миран и поштован излет – без стреса.'
}, {
  title: 'Плакати за кабинет веронауке',
  text: '20 плаката који чине учионицу јасном и безбедном.',
  items: ['Правила разговора', 'Празници у години', 'Четири поста', 'Делови храма', 'Десет заповести'],
  benefit: 'Одштампајте и окачите – одмах.'
}];

export const steps = [{
  title: 'Отворите ВЕРОНАУКУ СПРЕМНУ™',
  text: 'Преузмите пакет и отворите том који Вам треба – годишњи план, Свето писмо, празнике, светитеље, вредности или оцењивање.'
}, {
  title: 'Изаберите час',
  text: 'Пронађите разред и изаберите час или листић у одговарајућем нивоу.'
}, {
  title: 'Припремите се за 5 минута',
  text: 'Прођите кроз наставничку страну, материјал и безбедан оквир.'
}, {
  title: 'Одштампајте и предајте',
  text: 'Одштампајте листиће или их прикажите на екрану – и уђите у учионицу са јасним планом.'
}];

export const audienceItems = ['Предајете веронауку од 1. до 8. разреда', 'Желите целу годину веронауке организовану на једном месту', 'Желите безбедан и поштован оквир за свако дете', 'Желите прецизне датуме празница по јулијанском календару', 'Треба Вам план за замену и родитељски састанак', 'Треба Вам листићи у три нивоа', 'Желите готове критеријуме и коментаре за описно оцењивање', 'Желите да почнете за 5 минута'];

export const timeValueTasks = ['Тражење прича и тачних датума празника', 'Писање правила разговора и безбедног оквира', 'Прављење листића у више нивоа', 'Писање писама родитељима и планова посета', 'Прављење тестова и коментара за описно оцењивање'];

export const offerRows = [{
  label: '6 дигиталних томова – 240 страна',
  detail: 'Годишњи план и часови, Свето писмо, црквена година и празници, светитељи и храм, вредности и молитва, оцењивање'
}, {
  label: '5 бонуса без додатног трошка',
  detail: 'Веронаука за 5 минута, мапа замене, комуникација са родитељима, водич за посету храму и плакати'
}, {
  label: 'За 1–8. разред',
  detail: '12 часова минут по минут, листићи у три нивоа, тестови са решењима и 100 готових коментара'
}];

export const offerIncludes = ['Тренутно дигитално преузимање', 'ПДФ датотеке за чување', 'Листићи за штампу', 'Не шаље се физички производ'];

export const testimonials: Array<{
  quote: string;
  name: string;
  location: string;
}> = [];

export const faqs = [{
  q: 'Како добијам материјал?',
  a: 'ВЕРОНАУКА СПРЕМНА™ се испоручује дигитално. После куповине добијате приступ ПДФ датотекама које можете да преузмете и сачувате. Материјал можете да користите на рачунару, таблету и телефону и да одштампате стране које су Вам потребне.'
}, {
  q: 'За који узраст је намењен?',
  a: 'За 1–8. разред основне школе. Добијате годишње планове и часове за све узрасте.'
}, {
  q: 'Да ли је садржај веран православној традицији?',
  a: 'Да. Материјал је написан у складу са традицијом Српске православне цркве, са календаром по јулијанском рачунању (Божић 7. јануара, Савиндан 27. јануара, Васкрс). То је самосталан наставни материјал и није издање нити одобрење Цркве или Министарства просвете.'
}, {
  q: 'Да ли је материјал прилагођен деци различитих породица?',
  a: 'Да. Сваки час има безбедан оквир: говоримо шта верују православни хришћани, нико није обавезан да верује или да се моли, а свако дете може да каже „прескачем”.'
}, {
  q: 'Шта је у шест томова?',
  a: 'Том 1: годишњи план и 12 часова. Том 2: Свето писмо – приче за децу по узрасту. Том 3: црквена година и празници. Том 4: светитељи, иконе и храм. Том 5: хришћанске вредности и молитва у свакодневици. Том 6: оцењивање и праћење.'
}, {
  q: 'Немам посебну спрему за веронауку. Да ли ће ми помоћи?',
  a: 'Да. Сваки час има наставничку страну са циљем, материјалом, безбедним оквиром и планом минут по минут, тако да знате шта да радите и да кажете.'
}, {
  q: 'Шта су бонуси?',
  a: 'Веронаука за 5 минута, Мапа замене, Комуникација са родитељима, Водич за посету храму и манастиру и Плакати за кабинет веронауке.'
}, {
  q: 'Да ли ми материјал помаже око описног оцењивања?',
  a: 'Да. Том 6 даје критеријуме, тестове А/Б са решењима и 100 готових коментара. То је помоћно средство; одлуке о оцењивању доносите Ви и Ваша школа.'
}, {
  q: 'Могу ли да штампам?',
  a: 'Да. Сви листићи су прилагођени штампи на А4.'
}, {
  q: 'Колико кошта?',
  a: 'Једнократно плаћање од 2490 дин. (редовна цена 5990 дин.). Без претплате.'
}, {
  q: 'Могу ли да вратим новац?',
  a: 'Да, имате 7 дана гаранције задовољства. Гаранција не утиче на Ваша права према важећем закону о заштити потрошача.'
}, {
  q: 'Могу ли да користи више колега?',
  a: 'Материјал је за лично коришћење купца. Слободно делите идеје, али не и саме датотеке.'
}, {
  q: 'Која је разлика између томова?',
  a: 'Том 1 је оквир године. Томови 2–5 су продубљивање тема. Том 6 даје оцењивање.'
}, {
  q: 'Шта ако ми је потребна помоћ?',
  a: 'Јавите нам се преко странице за контакт. Одговарамо што пре.'
}];

export const footerLinks = ['Услови куповине', 'Политика приватности', 'Политика поврата новца', 'Контакт'];

export const pageSamples: Array<{ src: string; label: string; title: string; text: string }> = pageTexts.map((page, index) => ({
  ...page,
  src: PAGE_URLS[index] || ''
}));
